/**
 * @name text_node
 */

export const text = {
  group: 'inline',
  // TODO: toDebugString needs to be passed with createToPmFactory when migrate in https://product-fabric.atlassian.net/browse/ED-23606
  toDebugString: process.env.NODE_ENV !== 'production' ? undefined : () => 'text_node'
};